import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader2.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader2 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo; 
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName = branding?.brandName || user?.brandName || "Travel Agency";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // 1️⃣ BUILDER MODE
    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    } 
    // 2️⃣ PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // 3️⃣ LIVE MODE
    else {
      // let <Link> handle normally
    }

    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>

        {/* Logo Section */}
        <div className={styles.logoContainer}>
          <Link to="/" onClick={(e) => handleNavClick(e, { path: "/" })} className={styles.logoSkew}>
            {logoUrl ? (
              <img src={logoUrl} alt={brandName} className={styles.logoImage} />
            ) : (
              <h2 className={styles.textLogo}>{brandName}</h2>
            )}
          </Link>
        </div>

        <div className={styles.rightSection}>

          <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
            <ul className={styles.navList}>
              {headerMenu.map((item) => (
                <li key={item.id} className={styles.navItem}>
                  <Link
                    to={item.path}
                    onClick={(e) => handleNavClick(e, item)}
                    className={styles.navLink}
                  >
                    <span className={styles.navSlash}>//</span> {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.ctaContainer}>
            <button className={styles.bookBtn}>
              <span className={styles.btnText}>Book Now</span>
            </button>
          </div>

          <div
            className={styles.mobileToggle}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>

        </div>
      </div>

      <div className={styles.bottomAccent}></div>
    </header>
  );
};

export default TemplateHeader2;